module.exports = __webpack_public_path__ + "static/media/selection-Henley_Morgan.17a613df.jpg";